module.exports = __webpack_public_path__ + "img/reward.0be6759a.svg";